module.exports = __webpack_public_path__ + "carat.8a614962be61b1a96c7d20b7e54ccfa8.svg";